var Curriculog = Curriculog || {};

Curriculog.AgendaAdmins = (function ($, _, Backbone, AgendaAdmins) {

    AgendaAdmins = Curriculog.CurriculogCollection.extend({
        isAgendaAdmin: function (committeeID, userID) {
            var adminRecords = this.filter(function (model) {
                return model.get('committee_id') === committeeID && model.get('user_id') === userID && model.get('agenda_admin') == 1;
            });

            if (adminRecords.length > 0) {
                return true;
            } else {
                return false;
            }
        },

        getAdminsForCommittee: function (committeeID) {
            return this.filter(function (model) {
                return model.get('committee_id') === committeeID && model.get('agenda_admin') == 1;
            });
        },
    });
    return AgendaAdmins;

})($, _, Backbone, Curriculog.AgendaAdmins || {});